<script setup lang="ts">
defineProps({
  collectible: {
    type: Object as PropType<Collectible>,
    required: true,
  },
});

const { trackEvent } = useGAnalytics();
const userStore = useUserStore();
const isModalListingShown = ref<boolean>(false);
const listAction = ref<"list" | "edit" | "cancel">("list");

const beginListing = () => {
  listAction.value = "list";
  isModalListingShown.value = true;
};

const editListing = () => {
  listAction.value = "edit";
  isModalListingShown.value = true;
};

const cancelListing = () => {
  listAction.value = "cancel";
  isModalListingShown.value = true;
};
</script>
<template>
  <div class="flex flex-wrap items-center px-5 pt-4 pb-5 gap-x-2 gap-y-4">
    <BaseButtonSubmit
      v-if="collectible.price?.GFAL"
      text="Edit Listing"
      data-test="button-edit-listing"
      class="w-72"
      :contextual-styles="true"
      @click="editListing(), trackEvent('list_edit')" />
    <BaseButtonCancel
      v-if="collectible.price?.GFAL"
      text="Cancel Listing"
      data-test="button-cancel-listing"
      class="w-72"
      :contextual-styles="true"
      @click="cancelListing(), trackEvent('list_cancel')" />
    <BaseButtonSubmit
      v-else
      text="List for Sale"
      :disabled="!userStore.accountAddress"
      data-test="button-list-for-sale"
      class="w-72"
      :contextual-styles="true"
      @click="beginListing(), trackEvent('list_collectible')" />
  </div>
  <ModalListing
    v-if="isModalListingShown"
    :action="listAction"
    :collectible="collectible"
    @close="isModalListingShown = false" />
</template>
